import { render, staticRenderFns } from "./TimeOffRequestModal.vue?vue&type=template&id=2870165d&scoped=true"
import script from "./TimeOffRequestModal.vue?vue&type=script&lang=js"
export * from "./TimeOffRequestModal.vue?vue&type=script&lang=js"
import style0 from "./TimeOffRequestModal.vue?vue&type=style&index=0&id=2870165d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2870165d",
  null
  
)

export default component.exports